export default function ServeLogin() {
    // const appUrl = 'http://127.0.0.1:8000/api/';
    const appUrl = 'https://genoma-server.azurewebsites.net/api/';
    // const appUrl = 'https://safebox-server-homologacao.azurewebsites.net/api/';
    return appUrl;
}